import FormClient from "./FormClient";

export default function SeminarFormPage() {
    return <FormClient />;
}

